import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { insertGuest } from 'modules/accommodations/features/reservations/api';

export const useMutationInsertGuest = () => {
  const queryClient = useQueryClient();
  const { errorToast } = useCustomToast();

  const { mutateAsync, isLoading, isError, data } = useMutation(insertGuest, {
    onSettled: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_INSERT_NEW_GUEST);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_INSERT_NEW_GUEST);
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.ErrorDescription;
      errorToast(errorMessage);
    },
  });

  return {
    insertNewGuestMutation: mutateAsync,
    insertNewGuestLoading: isLoading,
    insertNewGuestError: isError,
    insertedGuestId: data,
  };
};
